<kendo-dialog *ngIf="open" [width]="500" (close)="close()">
    <kendo-dialog-titlebar>
        <h3>{{ 'SELECT-METHOD' | translate }}</h3>
    </kendo-dialog-titlebar>
    <div class="row m-2" *ngIf="memberSelected?.cellPhoneNumber !== null && memberSelected?.cellPhoneNumber !== ''">
        <div class="col">
            <input type="radio" value="sms" name="methodRequest" [(ngModel)]="methodRequest" id="methodSMS"
                kendoRadioButton />
            <label class="k-radio-label" for="methodSMS">{{'SMS' | translate}}:
                {{memberSelected.cellPhoneNumber | phone}}
            </label>
        </div>
    </div>
    <div class="row m-2" *ngIf="memberSelected?.email !== null && memberSelected?.email !== ''">
        <div class="col">
            <input type="radio" value="email" name="methodRequest" [(ngModel)]="methodRequest" id="methodEmail"
                kendoRadioButton />
            <label class="k-radio-label" for="methodEmail">{{'EMAIL' | translate}}: {{memberSelected.email}}
            </label>
        </div>
    </div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="close()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick preventTime="5000" [disabled]="methodRequest === undefined || sending"
            class="k-button k-primary" (click)="send($event)">{{ 'SEND' | translate }}<i class="fal fa-paper-plane"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>